/*
 * @Descripttion: 空状态
 * @Author: 郑泳健
 * @Date: 2022-12-19 16:45:16
 * @LastEditors: 郑泳健
 * @LastEditTime: 2023-02-07 11:47:03
 */
import * as React from 'react'
import { ConfigConsumer } from './context'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'

const defaultRenderEmpty = (conponentName: string) => (
  <ConfigConsumer>
    {({ getPrefixCls }) => {
      const prefix = getPrefixCls('empty')

      return (
        <LocaleReceiver componentName="TntdCascader">
          {(locale) => {
            return (
              <div className={`tntd-cascader-no-data-wrapper ${prefix}`}>
                <img
                  style={{ width: 80, height: 50, marginTop: 35 }}
                  src={require('../../img/no-data-s.png').default}
                />
                <div className="tntd-cascader-no-data-content">
                  {(locale as Record<'noDate', object>).noDate}
                </div>
              </div>
            )
          }}
        </LocaleReceiver>
      )
    }}
  </ConfigConsumer>
)

export type RenderEmptyHandler = typeof defaultRenderEmpty

export default defaultRenderEmpty
